import { JDDevice } from '@jdreact/jdreact-core-lib';

const deviceHeight = JDDevice.height;

export default deviceHeight;
